import React from "react";
import { isSet } from "../../../Utils/CommonFunctions";
import ScmInputTextField from "./ScmInputTextField";
import ScmOutputTextField from "./ScmOutputTextField";
import ScmDatatableField from "./ScmDatatableField";
import ScmDecisionMaking from "./ScmDecisionMaking";
import ScmInputSectionField from "./ScmInputSectionField";
import ScmButtons from "./ScmButtons"; 
import ScmFormField from "./ScmFormField";
import ScmForField from "./ScmForField";

const ElementBuilder = ({ tagName, attributes, elmtParams }) => {
    const {convertAndRenderElement} = elmtParams;
    const {loopData,dataTable,children,childActionButtons,dynamicVar,formScope,divName} = elmtParams;
    const commonProps = { attributes, elmtParams };

   switch (tagName) {
    case "scm:form":
        return <ScmFormField {...commonProps} />
    case "scm:inputtext":
        return  <ScmInputTextField {...commonProps} />
    case "scm:outputtext":
    case "scm:outputimage":
        return <ScmOutputTextField {...commonProps} />
    case "scm:datatable":
        return <ScmDatatableField {...commonProps} />
    case "scm:for":
        return <ScmForField {...commonProps} />
    case "scm:decision":
    case "scm:if":
        return <ScmDecisionMaking {...commonProps} />
    case "scm:inputsection":
        return <ScmInputSectionField {...commonProps} />
    case "scm:button":
        return <ScmButtons {...commonProps} />
    default:
        if(isSet(children,[]).length===0){
            return React.createElement(tagName, {...attributes});
        }else{
            return React.createElement(tagName, {...attributes}, convertAndRenderElement(children,{loopData,dataTable,dynamicVar,childActionButtons}));
       }
    }
};

export default ElementBuilder;
